import type { InviteApiSuccessResponse } from './types';

const INVITE_USERS_WITHIN_ORG_ENDPOINT = '/gateway/api/growth/groot-invite-within-org/invite';

export const inviteWithinOrg = async (
	userIds: string[],
	continueUrl: string,
	tenantId: string,
	product: string,
	sourceProduct?: string,
): Promise<Array<InviteApiSuccessResponse>> => {
	const resources = [`ari:cloud:${product}::site/${tenantId}`];
	const response = await fetch(INVITE_USERS_WITHIN_ORG_ENDPOINT, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			continueUrl,
			resources,
			userIds,
			cloudId: tenantId,
			experience: 'invite-on-page-publish',
			sourceProduct,
		}),
	});
	const body = await response.json();

	if (!Array.isArray(body) || response.status >= 400) {
		throw new InviteError(response.status, body);
	}

	return body;
};

export class InviteError extends Error {
	constructor(
		public status: number,
		public body: unknown,
	) {
		super('Failed to invite');
	}
}
